export default __webpack_public_path__ + "static/media/bantuanBanjirFundraisingChi.9c737505.jpg";